import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Collapse } from 'react-bootstrap';
import { Trans } from 'react-i18next';
import SessionManager from '../util/SessionManager';
import { getBaseUrl } from '../util/HelpfulFunctions';

class Sidebar extends Component {
    state = {};

    toggleMenuState(menuState) {
        if (this.state[menuState]) {
            this.setState({ [menuState]: false });
        } else if (Object.keys(this.state).length === 0) {
            this.setState({ [menuState]: true });
        } else {
            Object.keys(this.state).forEach(i => {
                this.setState({ [i]: false });
            });
            this.setState({ [menuState]: true });
        }
    }

    componentDidUpdate(prevProps) {
        if (this.props.location !== prevProps.location) {
            this.onRouteChanged();
        }
    }

    onRouteChanged() {
        document.querySelector('#sidebar').classList.remove('active');
        Object.keys(this.state).forEach(i => {
            this.setState({ [i]: false });
        });

        // Define paths for drop-down menus here
        const dropdownPaths = [
            { path: '/custInfo', state: 'custInfoMenuOpen' },
            { path: '/salesOrders', state: 'salesOrdersMenuOpen' },
            { path: '/misc', state: 'miscMenuOpen' },
            { path: '/admin', state: 'adminMenuOpen' }
        ];


        dropdownPaths.forEach((obj => {
            if (this.isPathActive(obj.path)) {
                this.setState({ [obj.state]: true })
            }
        }));

    }

    render() {
        return (
            <nav className="sidebar sidebar-offcanvas" id="sidebar">

                <div className="text-center sidebar-brand-wrapper d-flex align-items-center">
                    <a className="sidebar-brand brand-logo" href="index.html"><img src={getBaseUrl() + "/assets/logo.svg"} alt="logo" /></a>
                    <a className="sidebar-brand brand-logo-mini pt-3" href="index.html"><img src={getBaseUrl() + "/assets/logo-mini-light.svg"} alt="logo" /></a>
                </div>

                {this.renderUserMenu()}
                {this.renderAdminMenu()}
            </nav>
        );
    }

    renderUserMenu() {
        if (SessionManager.isUserAdmin)
            return <div/>

        return (
            <ul className="nav">
                <li className={this.isPathActive('/overview') ? 'nav-item active' : 'nav-item'}>
                    <Link className="nav-link" to="/dashboard">
                        <i className="mdi mdi-chart-line menu-icon"></i>
                        <span className="menu-title"><Trans>Σύνοψη</Trans></span>
                    </Link>
                </li>

                <li className={this.isPathActive('/custInfo') ? 'nav-item active' : 'nav-item'}>
                    <div className={this.state.custInfoMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('custInfoMenuOpen')} data-toggle="collapse">
                        <i className="mdi mdi-information-outline menu-icon"></i>
                        <span className="menu-title"><Trans>Πληροφόρηση</Trans></span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={this.state.custInfoMenuOpen}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item"> <Link className={this.isPathActive('/custInfoDrafts') ? 'nav-link active' : 'nav-link'} to="/custInfoDrafts"><Trans>Αξιόγραφα</Trans></Link></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/custInfoOpenTrans') ? 'nav-link active' : 'nav-link'} to="/custInfoOpenTrans"><Trans>Ανοιχτές κινήσεις</Trans></Link></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/custInfoOrderHistory') ? 'nav-link active' : 'nav-link'} to="/custInfoOrderHistory"><Trans>Οι παραγγελίες μου</Trans></Link></li>
                        </ul>
                    </Collapse>
                </li>

                <li className={this.isPathActive('/salesOrders') ? 'nav-item active' : 'nav-item'}>
                    <div className={this.state.salesOrdersMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('salesOrdersMenuOpen')} data-toggle="collapse">
                        <i className="mdi mdi-cart-outline menu-icon"></i>
                        <span className="menu-title"><Trans>Παραγγελίες</Trans></span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={this.state.salesOrdersMenuOpen}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item"> <Link className={this.isPathActive('/salesOrdersOrderHistory') ? 'nav-link active' : 'nav-link'} to="/salesOrdersOrderHistory"><Trans>Οι παραγγελίες μου</Trans></Link></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/salesOrdersProductCatalog') ? 'nav-link active' : 'nav-link'} to="/salesOrdersProductCatalog"><Trans>Κατάλογος</Trans></Link></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/salesOrdersSalesBasket') ? 'nav-link active' : 'nav-link'} to="/salesOrdersSalesBasket"><Trans>Καλάθι αγορών</Trans></Link></li>
                        </ul>
                    </Collapse>
                </li>

                <li className={this.isPathActive('/misc') ? 'nav-item active' : 'nav-item'}>
                    <div className={this.state.miscMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('miscMenuOpen')} data-toggle="collapse">
                        <i className="mdi mdi-dots-horizontal menu-icon"></i>
                        <span className="menu-title"><Trans>Χρήσιμα links</Trans></span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={this.state.miscMenuOpen}>
                        <ul className="nav flex-column sub-menu">
                            {/* <li className="nav-item"> <Link className={this.isPathActive('/miscFAQ') ? 'nav-link active' : 'nav-link'} to="/miscFAQ"><Trans>Βοήθεια</Trans></Link></li> */}
                            <li className="nav-item"> <a className={this.isPathActive('/miscFAQ') ? 'nav-link active' : 'nav-link'} href={getBaseUrl() + "/assets/documents/help.pdf"} target="_blank"><Trans>Βοήθεια</Trans></a></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/miscContact') ? 'nav-link active' : 'nav-link'} to="/miscContact"><Trans>Επικοινωνία</Trans></Link></li>
                            <li className="nav-item"> <a className={this.isPathActive('/miscAegeanWeb') ? 'nav-link active' : 'nav-link'} href="http://www.aegeanoil.com/" data-title="Help" target="_blank"><Trans>AEGEAN Website</Trans></a></li>
                        </ul>
                    </Collapse>
                </li>
            </ul>
        );
    }

    renderAdminMenu() {

        if (!SessionManager.isUserAdmin)
            return <div/>;
        
        return (
            <ul className="nav">
                <li className={this.isPathActive('/admin') ? 'nav-item active' : 'nav-item'}>
                    <div className={this.state.adminMenuOpen ? 'nav-link menu-expanded' : 'nav-link'} onClick={() => this.toggleMenuState('adminMenuOpen')} data-toggle="collapse">
                        <i className="mdi mdi-information-outline menu-icon"></i>
                        <span className="menu-title"><Trans>Διαχείριση</Trans></span>
                        <i className="menu-arrow"></i>
                    </div>
                    <Collapse in={this.state.adminMenuOpen}>
                        <ul className="nav flex-column sub-menu">
                            <li className="nav-item"> <Link className={this.isPathActive('/adminUsers/all') ? 'nav-link active' : 'nav-link'} to="/adminUsers/all"><Trans>Χρήστες Portal</Trans></Link></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/adminUsers/active') ? 'nav-link active' : 'nav-link'} to="/adminUsers/active"><Trans>Ενεργοί χρήστες</Trans></Link></li>
                            <li className="nav-item"> <Link className={this.isPathActive('/adminUsers/inactive') ? 'nav-link active' : 'nav-link'} to="/adminUsers/inactive"><Trans>Ανενεργοί χρήστες</Trans></Link></li>
                        </ul>
                    </Collapse>
                </li>
            </ul>
        );
    }

    // Check if the current address belongs to a path
    isPathActive(path) {
        return this.props.location.pathname.startsWith(path);
    }

    componentDidMount() {
        this.onRouteChanged();
        // add className 'hover-open' to sidebar navitem while hover in sidebar-icon-only menu
        const body = document.querySelector('body');
        document.querySelectorAll('.sidebar .nav-item').forEach((el) => {

            el.addEventListener('mouseover', function () {
                if (body.classList.contains('sidebar-icon-only')) {
                    el.classList.add('hover-open');
                }
            });
            el.addEventListener('mouseout', function () {
                if (body.classList.contains('sidebar-icon-only')) {
                    el.classList.remove('hover-open');
                }
            });
        });
    }

}

export default withRouter(Sidebar);